import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { wait } from "../utility/wait";

interface EventValueQuestionProps {
  eventValue: number | null;
  setEventValue: React.Dispatch<React.SetStateAction<number | null>>;
  isAutoPageTurn?: boolean;
  questionnairePage: number;
  switchTab: (next: number) => void;
}

export const EventValueQuestion: React.FC<EventValueQuestionProps> = ({
  eventValue,
  setEventValue,
  isAutoPageTurn,
  questionnairePage,
  switchTab,
}) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setEventValue(Number((event.target as HTMLInputElement).value));
    if (isAutoPageTurn) {
      await wait(100);
      switchTab(questionnairePage + 1);
    }
  };

  return (
    <>
      <Box sx={{ padding: "1rem" }}>
        <Typography variant="caption">
          思い出した良い出来事は、あなたにとってどのくらい良いものですか？今の気持ちとしてもっとも当てはまるものを選んでください。
        </Typography>
      </Box>
      <Box sx={{ padding: "1rem" }}>
        <FormControl>
          <RadioGroup onChange={handleChange} value={eventValue}>
            <FormControlLabel
              value={10}
              control={<Radio />}
              label="10：最高に良い"
            />
            <FormControlLabel value={9} control={<Radio />} label="9" />
            <FormControlLabel value={8} control={<Radio />} label="8" />
            <FormControlLabel value={7} control={<Radio />} label="7" />
            <FormControlLabel value={6} control={<Radio />} label="6" />
            <FormControlLabel value={5} control={<Radio />} label="5" />
            <FormControlLabel value={4} control={<Radio />} label="4" />
            <FormControlLabel value={3} control={<Radio />} label="3" />
            <FormControlLabel value={2} control={<Radio />} label="2" />
            <FormControlLabel
              value={1}
              control={<Radio />}
              label="1：良くも悪くもない"
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </>
  );
};
